'use strict';

define([], function() {
  return function(iframe, options) {
    // Set up default options.
    options = options || {};
    options.blurCallback = options.blurCallback || Function.prototype;

    var iframeTracker = {
      iframe: iframe,
      isMouseOver: false,
      _bindEvent: function(el, event, handler) {
        if (el.addEventListener) {
          el.addEventListener(event, handler, false);
        } else if (el.attachEvent) {
          el.attachEvent('on' + event, handler);
        } else {
          el['on' + event] = handler;
        }
      },
      _unbindEvent: function(el, event, handler) {
        if (el.removeEventListener) {
          el.removeEventListener(event, handler, false);
        } else if (el.detachEvent) {
          el.detachEvent('on' + event, handler);
        } else {
          el['on' + event] = null;
        }
      },
      _bindEvents: function() {
        this._bindEvent(this.iframe, 'mouseover', this._onMouseOver);
        this._bindEvent(this.iframe, 'mouseleave', this._onMouseLeave);
        this._bindEvent(window, 'blur', this._onBlur);
      },
      _unbindEvents: function() {
        this._unbindEvent(this.iframe, 'mouseover', this._onMouseOver);
        this._unbindEvent(this.iframe, 'mouseleave', this._onMouseLeave);
        this._unbindEvent(window, 'blur', this._onBlur);
      },
      _onMouseOver: function() {
        iframeTracker.isMouseOver = true;
      },
      _onMouseLeave: function() {
        iframeTracker.isMouseOver = false;
      },
      _onBlur: function() {
        if (iframeTracker.isMouseOver) {
          options.blurCallback();
        }
      }
    }

    iframeTracker._bindEvents();
    return iframeTracker;
  };
});